import React from 'react';
import { Avatar, Box, Grid, Typography } from '@mui/material';
import { PluginConnections } from 'types/PluginConnections';
import { ErrorStatusIcon, SuccessStatusIcon } from 'components/SVG';

type PluginConnectionItemProps = {
  pluginConnection?: PluginConnections | undefined;
  onClick: () => void;
  isActive: boolean;
};

function PluginConnectionItem({
  pluginConnection,
  onClick,
  isActive,
}: PluginConnectionItemProps) {
  return (
    <Grid
      item
      container
      xs={12}
      justifyContent='space-between'
      alignItems='center'
      component='div'
      onClick={onClick}
      sx={{
        cursor: 'pointer',
        backgroundColor: 'white',
        padding: 1.5,
        borderRadius: 1,
      }}
    >
      <Grid item flex={1} display='flex' alignItems='center'>
        <Avatar sx={{ width: 24, height: 24 }}>
          {isActive ? <SuccessStatusIcon /> : <ErrorStatusIcon />}
        </Avatar>
        <Box marginLeft={2}>
          <Typography
            sx={{
              color: '#404040',
              fontSize: '16px',
              fontStyle: 'normal',
              lineHeight: 'normal',
              fontFamily: 'Mont-SemiBold',
            }}
          >
            {pluginConnection?.attributes.name}
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
}

export default PluginConnectionItem;
